export const getters = {
  systemConsignees: state => state.consignees,
  Consignee: state => state.systemConsignee
};
export default getters;



// WEBPACK FOOTER //
// ./src/vuex/modules/consignees/getters.js